import React, { useEffect, useRef, useState } from "react";
import type { IFoodAmount } from "../../shared/Recipes";
import FoodRow from "./FoodRow";
import TextInput, { Formatters } from "../../gui/TextInput/TextInput";
import Button from "../../gui/Button/Button";
import AddIcon from "../../gui/Icons/AddIcon";
import FormControl from "../../gui/Form/FormControl";
import Validators from "../../gui/Form/Validators";
import { RecipeFullscreen } from "../Dialogs/FullscreenDlg";
import _ from "lodash"

export default function() {
    const {item,update} = RecipeFullscreen.useFullscreen()
    const [items,setItems] = useState<IFoodAmount[]>(item.foods.slice(0))
    const nameRef = useRef<any>()
    const servingRef = useRef<any>()
    const descRef = useRef<any>()
    const mounted = useRef<boolean>(false)

    const onChange = () => {
        const dirty = item.name!=nameRef.current?.value || item.servings!=servingRef.current?.value || item.description!=descRef.current?.value || !_.isEqual(item.foods, items)
        const valid = !!nameRef.current?.value && !!servingRef.current?.value && !items.find(i => !i.id || !i.amount)
        update(dirty, valid, {
            name:nameRef.current?.value,
            servings:parseInt(servingRef.current?.value),
            description:descRef.current?.value,
            foods:items
        })
    }

    useEffect(() => {
        if (mounted.current) onChange()
        else mounted.current = true
    }, [items, item])

    const onAdd = () => { setItems(items => [...items,{id:0,amount:0,unit:"g"}]) }
    const onUpdate = (index:number,foodAmount:IFoodAmount) => { 
        setItems(items => {
            items.splice(index, 1, foodAmount)
            return [...items]
        }); 
    }
    const onDelete = (index:number) => {
        setItems(items => {
            items.splice(index, 1)
            return [...items]
        })
    }
    const foods = items.map( (food,i) => <FoodRow key={i.toString()+":"+food.id} index={i} foodIds={item.foods.map(f => f.id)} foodAmount={food} onUpdate={onUpdate} onDelete={onDelete}/> )
    return <div className="recipeEdit flex vert gap-24">
        <div className="flex gap-16">
            <FormControl className="flex1" validators={[Validators.Required("Name")]}>
                <TextInput placeholder="Name" float={true} defaultValue={item.name} ref={nameRef} onUpdate={onChange}/>
            </FormControl>
            <FormControl validators={[Validators.PositiveNumber("Servings")]}>
                <TextInput className="serving" placeholder="Servings" float={true} defaultValue={item.servings?.toString() || ""} ref={servingRef} onUpdate={onChange} formatter={Formatters.PositiveRealNumber}/>
            </FormControl>
        </div>
        <TextInput className="desc" multiline={true} placeholder="Description" float={true} defaultValue={item.description || ""} ref={descRef} onUpdate={onChange}/>
        <div className="ingList">
            {foods}
            <Button className="colspan" onClick={onAdd}><AddIcon/> Add ingredient</Button>
        </div>
    </div>
}